import styled from '@emotion/styled'

export const Wrapper = styled.div`
  margin-top: 25px;
`
